<template>
  <div>
    <div :class="$style.header">
      <div class="text-dark">
        我的收藏
      </div>
      <button class="ml-auto" @click="$emit('close')">
        <i class="el-icon-close" />
      </button>
    </div>
    <div :class="$style.cruiseList">
      <el-skeleton v-if="loading">
        <template #template>
          <div class="flex p-4">
            <el-skeleton-item class="w-41 h-28 rounded" variant="image" />
            <div class="flex-1 ml-4">
              <el-skeleton-item variant="h3" />
              <el-skeleton-item variant="p" class="w-4/5 mt-1.5" />
              <el-skeleton-item variant="rect" class="w-2/3 mt-1.5" />
              <el-skeleton-item variant="rect" class="w-1/3 mt-1.5" />
              <div class="flex justify-between mt-1.5">
                <el-skeleton-item class="w-1/4" variant="rect" />
                <el-skeleton-item class="w-1/4" variant="rect" />
                <el-skeleton-item class="w-1/4" variant="rect" />
              </div>
            </div>
          </div>
        </template>
      </el-skeleton>
      <template v-else>
        <el-empty v-if="!cruises.length" :image-size="212" image="~@/assets/img/company/search/empty.png" description="暂无收藏" />
        <el-scrollbar v-else :wrap-class="$style.scroller" :view-style="containerStyle">
          <index-cruise-item class="px-4" v-for="cruise in cruises" :key="cruise.id" :actions="['share', 'collection']" :cruise="cruise"
            @toggle-collection="onToggleCollection(cruise, $event)" />
        </el-scrollbar>
      </template>

    </div>
  </div>
</template>
<script>
import {
	defineComponent,
	onMounted,
	computed,
	ref
} from "@nuxtjs/composition-api";

import IndexCruiseItem from "./index-cruise-item.vue";
import { getAisCruiseCollectionList } from "~/services/company";
import { REQUEST_CODES } from "~/constants/const-http";
import useLayout from "~/composables/useLayout";


export default defineComponent({
	name: "IndexCollectList",
	components: {
		IndexCruiseItem
	},
	emits: ["load-next", "close"],
	setup(props, { emit }) {
		const loading = ref(true);
		async function fetchCruiseList() {
			loading.value = true;
			const { code, data, msg } = await getAisCruiseCollectionList();
			loading.value = false;
			if (code !== REQUEST_CODES.ERROR_OK) {
				throw new Error(msg);
			}
			cruises.value = data.map((item) => ({ ...item, collection: true }));
			return data;
		}
		const cruises = ref([]);
		onMounted(() => {
			fetchCruiseList();
		});

		function onToggleCollection(cruise) {
			cruises.value = cruises.value.filter((item) => item.id !== cruise.id);
		}

		const {headerSize} = useLayout();
		const containerStyle = computed(() => ({
			'max-height': `calc(100% - ${ headerSize.height + 198 }px)`
		}))
		return {
			loading,
			cruises,
			onToggleCollection,

			containerStyle
		};
	}
});
</script>
<style lang="scss" module>
.header {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.header::before {
  content: "";
  border-top-width: 1px;
  height: 0px;
  position: absolute;
  left: 1rem;
  right: 1rem;
  bottom: 0px;
}
.cruiseList {
  overflow: hidden;
  position: relative;
}
</style>